import dayjs from "dayjs"
import { useCallback } from "react"
import { useTranslation } from "@/hooks/useTranslation"

export const useTaskAfterTodayConfirm = () => {
    const { t } = useTranslation()
    const confirmTaskIsAfterToday = useCallback(
        ({
            taskDate
        }: {
            // YYYY-MM-DDの形式
            taskDate: string
        }) => {
            if (dayjs(taskDate).isAfter(dayjs(), "day")) {
                const confirmed = window.confirm(
                    t(
                        "こちらは明日以降の作業ですが、本当に開始してもよろしいですか？"
                    )
                )

                return confirmed
            }

            return true
        },
        [t]
    )

    return { confirmTaskIsAfterToday }
}
